module.exports = __webpack_public_path__ + "static/media/contacto.bf297bad.jpg";